import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
declare var jQuery: any;


@Component({
  selector: 'app-group-users-list',
  templateUrl: './query.component.html',
  styleUrls: ['./query.component.css']
})
export class QueryComponent implements OnInit {
	queryForm: FormGroup;
	queryList: any = [];
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	searchStr: any = '';
	activePageNo: number = 0;

	redirectUrl: any;
	referer: string = '';
	is_group_users = false;
	prev_token = null;
	groupMemberList = [];


	query_id = false;
	modalTitle:any;
	btnTitle:any;
	currentQuery:any;



	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private activatedRoute: ActivatedRoute, private validationService: ValidationService, private pagerService: PagerService) {
		this.activatedRoute.queryParamMap.subscribe(params => {
		
		});
		this.activatedRoute.params.subscribe(params => {
			
			if (params['query_id'] && params['query_id'] != undefined) {
				this.query_id = params['query_id'];
			}
		});
	}

	ngOnInit() {
		this.initializeQueryList();
		this.commonService.process();
	}

	initializeQueryList() {
		$('.navbar-brand').text('Query');
		this.commonService.setTitle();
		this.queryForm = new FormGroup({
			queryDescription: new FormControl("", Validators.compose([
				Validators.required
			])),
		});

		this.limit = 10;
		this.pageNo = 1;

		let route = this.router.url;
		if (route.indexOf("?backUrl") !== -1) {
			var routeArr = route.split('?backUrl=');
			var decodedUri = decodeURIComponent(routeArr[1]);
			var decodedArr = decodedUri.split("&");

			var decodedPageNo = decodedArr[0].split("pageNo=");
			this.pageNo = decodedPageNo[1];
			this.activePageNo = Number(decodedPageNo[1]);

			var decodedSearchStr = decodedArr[1].split("searchStr=");
			this.searchStr = decodedSearchStr[1];

			if (!this.is_group_users){
				console.log("1")
				this.getQueryList(this.pageNo, this.limit, this.searchStr);}
			else{}
				//this.getGroupMembersList(1, this.limit);
		}
		else if (route.indexOf("?type") !== -1) {
			var routeArr = route.split('?type=');
			this.referer = routeArr[1];
			if (!this.is_group_users){}
				//this.getDashboardUserList(1, this.limit, routeArr[1]);
			else{}
				//this.getGroupMembersList(1, this.limit);
		}
		else {
			if (!this.is_group_users){
                console.log("2")
				this.getQueryList(this.pageNo, this.limit, this.searchStr);}
			else{}
				//this.getGroupMembersList(1, this.limit);
		}

	}

	getQueryList = function (pageNo, limit, searchStr) {
		this.commonService.process();
		this.authService.getQueryList(pageNo, limit, searchStr, this.query_id).subscribe(data => {
			if (data.success) {
				
				var that = this;
				if (pageNo == this.activePageNo)
					setTimeout(function () {
						jQuery("#search").val(that.searchStr);
						jQuery('#page_' + that.activePageNo).addClass('active');
						if (that.activePageNo == 1)
							jQuery('#first, #prev').addClass('disabled');
						else if (that.activePageNo == that.pager.totalPages)
							jQuery('#next, #last').addClass('disabled');
					}, 100);
				this.queryList = data.queryList.data;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
				this.redirectUrl = 'pageNo=' + pageNo + '&searchStr=' + searchStr;
			}
			else {
				this.queryList = [];
			}

			this.commonService.hideProcess();
		});
	}
	resetForm()
	{
		this.queryForm.reset();
		
	}
	addReplyQuery = function (query) {
		this.resetForm();
		this.modalTitle = "Add Reply on Query";
		this.btnTitle = "Add Reply";
		this.currentQuery = query;
	}
	manageQuery= function (QueryForm) {
		QueryForm.query_id=this.currentQuery._id
		QueryForm.query_details_id=this.currentQuery.query_details._id
		if(this.queryForm.valid)
		{	
			this.btnTitle = "Saving...";
			$(':button[type="submit"]').attr('disabled', true);
			this.authService.addQuery(QueryForm).subscribe(data=>{
				if(data.success) {
					console.log("3")
					this.getQueryList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				$(':button[type="submit"]').attr('disabled', false);
				this.closeModel();
			});
		}
		else{
			this.validationService.validateAllFormFields(this.queryForm);
		}
	
	}

	closeModel = function()
	{
		$('.close').click();
	} 
	// Pagination
	setPage(page: number, param) {
		jQuery('.pages.active a').each(function () {
			if (parseInt($(this).text()) != page) {
				$(this).parent('li').removeClass('active');
			}
		});
		if (jQuery('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
			jQuery('#first, #prev').removeClass('disabled');
		if (jQuery('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
			jQuery('#next, #last').removeClass('disabled');
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		if (!this.is_group_users)
			this.pagedItems = this.queryList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		else
			this.pagedItems = this.groupMemberList.slice(this.pager.startIndex, this.pager.endIndex + 1);
			if (!param) {
				if (this.referer != ''){}
					//this.getDashboardUserList(page, this.limit, this.referer);
				else{
					console.log("4")
					this.getQueryList(page, this.limit, this.searchStr);}
			}
	}

	// Search user
	searchUser = function () {
		this.referer = '';
		this.searchStr = jQuery("#search").val();
		console.log("5")
		this.getQueryList(1, this.limit, this.searchStr);
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/query/query.component.ts